import { createFileRoute } from '@tanstack/react-router';

import { AboutPageView } from '@/components/site/pages';
import { seoHead } from '@/lib/seo';
import { absoluteUrl, SITE_NAME } from '@/lib/site-url';

export const Route = createFileRoute('/about')({
    head: () => {
        const base = seoHead({
            title: 'אודות',
            description:
                `${SITE_NAME} הוא מקור החדשות המוביל באשקלון מאז 2006 - חדשות אשקלון מהשטח, מבזקים, ספורט, חינוך, כלכלה ותרבות.`,
            path: '/about',
        });
        return {
            ...base,
            links: [
                ...base.links,
                {
                    rel: 'alternate',
                    type: 'text/markdown',
                    href: absoluteUrl('/about.md'),
                },
            ],
        };
    },
    component: AboutPage,
});

function AboutPage() {
    return <AboutPageView />;
}
